// Called only when playback is activated. Unknown AV1 metadata must never
// select a generic MP4 ahead of the existing, widely supported main video.
export const getBannerVideoSources = ({src, type, desktopAv1, mobile}, isDesktop, canPlayType) => {
    const main = {src, type};
    if (!isDesktop) return mobile?.mediaItemUrl
        ? [{src: mobile.mediaItemUrl, type: mobile.mimeType}]
        : [main];
    const av1Type = desktopAv1?.bannerAv1Type;
    if (desktopAv1?.mediaItemUrl && /^video\/mp4; codecs="av01\.\d\.\d{2}[MH]\.\d{2}"$/.test(av1Type || "") && canPlayType(av1Type)) {
        return [{src: desktopAv1.mediaItemUrl, type: av1Type}, main];
    }
    return [main];
};
